import React, { useState } from 'react';

import Observer from '@researchgate/react-intersection-observer';

import { AnimatedLinks } from '@ui/moleculs/atoms/AnimatedLinks';

import { ReactComponent as Menu1 } from '@assets/images/section-5/menu-1.svg';
import { ReactComponent as Menu2 } from '@assets/images/section-5/menu-2.svg';

import { ReactComponent as Menu1Mob } from '@assets/images/section-5/menu-1-mob.svg';
import { ReactComponent as Menu2Mob } from '@assets/images/section-5/menu-2-mob.svg';

import { ReactComponent as MenuNumber } from '@assets/images/section-5/menu-number.svg';

import Person1 from '@assets/images/section-5/person-1.webp';
import Person2 from '@assets/images/section-5/person-2.webp';
import Person3 from '@assets/images/section-5/person-3.webp';
import Person4 from '@assets/images/section-5/person-4.webp';
import Person5 from '@assets/images/section-5/person-5.webp';

import Person1Safari14 from '@assets/images/section-5/person-1-safari-14.png';
import Person2Safari14 from '@assets/images/section-5/person-2-safari-14.png';
import Person3Safari14 from '@assets/images/section-5/person-3-safari-14.png';
import Person4Safari14 from '@assets/images/section-5/person-4-safari-14.png';
import Person5Safari14 from '@assets/images/section-5/person-5-safari-14.png';

import Image1 from '@assets/images/section-5/item-1.webp';
import Image1Safari14 from '@assets/images/section-5/item-1-safari-14.png';

import styles from './index.module.css'

type PageProps = {
  scrollDir?: string;
  isDesktopOrLaptop?: any;
  browser: any;
};

export const Page5: React.FC<PageProps> = ({ ...props }) => {
  const [isVisible, setVisible] = useState([false]);
  const { scrollDir, isDesktopOrLaptop, browser } = props;

  const handleChange = (event: any | never, index: number) => {
    const currActive = isVisible[index];
    const updateArr = [ ...isVisible ];
    updateArr[index] = event.isIntersecting || (currActive && scrollDir === 'down')
    setVisible(updateArr);
  };

  const browserName = browser.name.toLowerCase();
  const browserVersion = browser.version.split('.')[0];

  return (
    <Observer
      onChange={event => handleChange(event, 0)}
      root={null}
      rootMargin="0% 0% -20%"
    >
      <article
        id="create"
        className={`
          ${isVisible[0] ? styles.active : ``}
          ${styles.section}
          relative
          max-w-1100
          w-full
          mx-auto
          text-white

          mb-27
          lg:mb-40
        `}
      >
        <header
          className={`
            flex
            lg:inline-flex
            justify-between
            lg:justify-start
            relative
            -mt-8
            lg:mt-0
            pt-8
            lg:pt-0
            pb-15
            lg:pb-8
            pl-8
            mr-4
            lg:pl-0
            lg:mr-0

            overflow-hidden
            lg:overflow-visible
          `}
        >
          <h1
            className={`
              inline-flex
              flex-col
              items-stretch
              lg:items-start
              relative
              font-bold
              min-w-full
              lg:min-w-0

              text-4.78xl
              lg:text-6.5xl
            `}
          >
            <span
              className={`
                relative
                transform
                duration-500
                transition-all
              `}
            >
              {isDesktopOrLaptop &&
                <Menu1
                  className={`
                    ${styles.menubg1}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    -ml-8
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />}
              <span className={`relative`}>Что даст</span>
            </span>
            <span
              className={`
                relative
                transform
                duration-500
                transition-all
              `}
            >
              {isDesktopOrLaptop &&
                <Menu2
                  className={`
                    ${styles.menubg2}
                    absolute
                    transform
                    duration-500
                    transition-all
                    mt-7
                    -ml-5
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />}
              <span className={`relative`}>газопровод</span>
            </span>
            <span
              className={`
                relative
                transform
                duration-500
                delay-700
                transition-all
              `}
            >
              {!isDesktopOrLaptop &&
                <>
                <Menu1Mob
                  className={`
                    ${styles.menubg1}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    -ml-4
                    -mt-2
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
                <Menu2Mob
                  className={`
                    ${styles.menubg2s}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    -ml-2.5
                    -mt-12
                    top-full
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                /></>}
              <span className={`relative`}>России и миру</span>
            </span>
          </h1>
          <h2 className={`
            absolute
            top-0
            lg:-top-8
            right-0
            lg:-right-8
            z-2
          `}>
            <MenuNumber
              width={isDesktopOrLaptop ? 175 : 138}
              height={isDesktopOrLaptop ? 230 : 182}
              className={`
                ${styles.number1}
                relative
                fill-current
              `}
            />
            <MenuNumber
              width={isDesktopOrLaptop ? 175 : 138}
              height={isDesktopOrLaptop ? 230 : 182}
              className={`
                ${styles.number2}
                absolute
                top-0
                right-0
                fill-current
              `}
            />
          </h2>
        </header>

        <Observer
          onChange={event => handleChange(event, 1)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              transform
              opacity-0
              translate-x-1/10

              ${isVisible[1]? (isDesktopOrLaptop ? `animate-opacity-x-inverse` : `animate-opacity`) : ``}

              max-w-890
              mb-16
              lg:mb-9vw
              mx-8
              lg:mx-auto
            `}
          >
            <div className={`flex flex-col lg:flex-row items-center w-full`}>
              <div className={`flex flex-1 justify-end`}>
                <div
                  className={`
                    ${isDesktopOrLaptop ? `max-h-180` : `max-h-151`}
                    inline-flex
                    rounded-full
                    p-3
                    border-6
                    border-solid
                    border-blue-default
                    lg:mr-11.5vw
                  `}
                >
                  <img
                    className={`rounded-full`}
                    src={(browserName === 'safari' && browserVersion < 15) ? Person1Safari14 : Person1}
                    width={isDesktopOrLaptop ? '144' : '115'}
                    height={isDesktopOrLaptop ? '144' : '115'}
                    alt=""
                  />
                </div>
              </div>
              <div
                className={`
                  relative
                  flex-1
                  text-sm
                  leading-6
                  text-white
                `}
              >
                <h3
                  className={`
                    uppercase
                    font-semibold
                    text-8.5xl
                    lg:text-10xl
                    lg:ml-11.5
                    -mt-8
                    lg:-mt-0
                    -mb-12
                    lg:-mb-12
                    leading-2
                    text-blue-default
                  `}
                >
                  “
                </h3>
                <span
                  className={`
                    lg:-mr-20
                    block
                    relative
                    text-base
                    lg:text-xl
                    leading-7-important
                    lg:leading-9-important
                    italic font-medium
                    mb-4
                    lg:mb-5vw
                    lg:ml-11.5vw
                  `}>
                  «Северный поток-2», вне всяких сомнений, это абсолютно очевидная вещь, так же как дважды два — четыре: выигрышная, выгодная для экономики Европы в целом и Германии в частности.
                </span>
                <span
                  className={`
                    lg:-mr-15
                    block relative text-right
                    text-xxs
                    lg:text-sm
                    italic
                    lg:ml-11.5vw
                  `}>
                  — Президент РФ Владимир Путин
                </span>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 2)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              transform
              opacity-0
              -translate-x-1/10

              ${isVisible[2]? (isDesktopOrLaptop ? `animate-opacity-x` : `animate-opacity`) : ``}

              max-w-890
              mb-16
              lg:mb-9vw
              mx-8
              lg:mx-auto
            `}
          >
            <div className={`flex flex-col lg:flex-row items-center w-full`}>
              <div
                className={`
                  relative
                  flex-1
                  text-sm
                  leading-6
                  text-white
                  order-2
                  lg:order-1
                `}
              >
                <h3
                  className={`
                    lg:-ml-20
                    uppercase
                    font-semibold
                    text-8.5xl
                    lg:text-10xl
                    lg:mr-11.5
                    -mt-8
                    lg:-mt-0
                    -mb-12
                    lg:-mb-12
                    leading-2
                    text-blue-default
                  `}
                >
                  “
                </h3>
                <span
                  className={`
                    lg:-ml-20
                    block
                    relative
                    text-base
                    lg:text-xl
                    leading-7-important
                    lg:leading-9-important
                    italic font-medium
                    mb-4
                    lg:mb-5vw
                    lg:mr-11.5vw
                  `}>
                  В стратегическом плане газопровод укрепит энергобезопасность Европы на десятилетия вперед. Именно поэтому заинтересованные в проекте европейские столицы твердо выступают за завершение строительства газопровода.
                </span>
                <span
                  className={`
                    block relative text-right
                    text-xxs
                    lg:text-sm
                    italic
                    lg:mr-15
                  `}>
                  — Глава МИД РФ Сергей Лавров
                </span>
              </div>
              <div
                className={`
                  flex
                  flex-1
                  justify-start
                  order-1
                  lg:order-2
                `}
              >
                <div
                  className={`
                    ${isDesktopOrLaptop ? `max-h-180` : `max-h-151`}
                    inline-flex
                    rounded-full
                    p-3
                    border-6
                    border-solid
                    border-blue-default
                    lg:ml-11.5vw
                  `}
                >
                  <img
                    className={`rounded-full`}
                    src={(browserName === 'safari' && browserVersion < 15) ? Person2Safari14 : Person2}
                    width={isDesktopOrLaptop ? '144' : '115'}
                    height={isDesktopOrLaptop ? '144' : '115'}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 3)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              transform
              opacity-0
              translate-x-1/10

              ${isVisible[3]? (isDesktopOrLaptop ? `animate-opacity-x-inverse` : `animate-opacity`) : ``}

              max-w-890
              mb-16
              lg:mb-9vw
              mx-8
              lg:mx-auto
            `}
          >
            <div className={`flex flex-col lg:flex-row items-center w-full`}>
              <div className={`flex flex-1 justify-end`}>
                <div
                  className={`
                    ${isDesktopOrLaptop ? `max-h-180` : `max-h-151`}
                    inline-flex
                    rounded-full
                    p-3
                    border-6
                    border-solid
                    border-blue-default
                    lg:mr-11.5vw
                  `}
                >
                  <img
                    className={`rounded-full`}
                    src={(browserName === 'safari' && browserVersion < 15) ? Person3Safari14 : Person3}
                    width={isDesktopOrLaptop ? '144' : '115'}
                    height={isDesktopOrLaptop ? '144' : '115'}
                    alt="" />
                </div>
              </div>
              <div
                className={`
                  relative
                  flex-1
                  text-sm
                  leading-6
                  text-white
                `}
              >
                <h3
                  className={`
                    uppercase
                    font-semibold
                    text-8.5xl
                    lg:text-10xl
                    lg:ml-11.5
                    -mt-8
                    lg:-mt-0
                    -mb-12
                    lg:-mb-12
                    leading-2
                    text-blue-default
                  `}
                >
                  “
                </h3>
                <span
                  className={`
                    lg:-mr-20
                    block
                    relative
                    text-base
                    lg:text-xl
                    leading-7-important
                    lg:leading-9-important
                    italic font-medium
                    mb-4
                    lg:mb-5vw
                    lg:ml-11.5vw
                  `}>
                  Завершение строительства «Северного потока-2» было правильным шагом, так как вместо огромной руины на морском дне у нас теперь есть связь с Россией, от которой обе стороны могут выиграть, даже когда наша потребность в ископаемом топливе снижается.
                </span>
                <span
                  className={`
                    lg:-mr-15
                    block relative text-right
                    text-xxs
                    lg:text-sm
                    italic
                    lg:ml-11.5vw
                  `}>
                  — Пресс-секретарь по иностранным делам парламентской
                  <br />
                  группы немецких социал-демократов Нильс Шмид
                </span>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 4)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              transform
              opacity-0
              -translate-x-1/10

              ${isVisible[4]? (isDesktopOrLaptop ? `animate-opacity-x` : `animate-opacity`) : ``}

              max-w-890
              mb-16
              lg:mb-9vw
              mx-8
              lg:mx-auto
            `}
          >
            <div className={`flex flex-col lg:flex-row items-center w-full`}>
              <div
                className={`
                  relative
                  flex-1
                  text-sm
                  leading-6
                  text-white
                  order-2
                  lg:order-1
                `}
              >
                <h3
                  className={`
                    lg:-ml-20
                    uppercase
                    font-semibold
                    text-8.5xl
                    lg:text-10xl
                    lg:mr-11.5
                    -mt-8
                    lg:-mt-0
                    -mb-12
                    lg:-mb-12
                    leading-2
                    text-blue-default
                  `}
                >
                  “
                </h3>
                <span
                  className={`
                    lg:-ml-20
                    block
                    relative
                    text-base
                    lg:text-xl
                    leading-7-important
                    lg:leading-9-important
                    italic font-medium
                    mb-4
                    lg:mb-5vw
                    lg:mr-11.5vw
                  `}>
                  Завершение строительства газопровода «Северный поток-2» в Балтийском море еще больше повысит надежность снабжения Европы. Ясно одно: «Северный поток—2» укрепляет независимость Европы, потому что энергоснабжение должно быть внутренним делом европейцев.
                </span>
                <span
                  className={`
                    block relative text-right
                    text-xxs
                    lg:text-sm
                    italic
                    lg:mr-15
                  `}>
                  — Глава Минэкономики Австрии Маргарита Шрамбек
                </span>
              </div>
              <div
                className={`
                  flex
                  flex-1
                  justify-start
                  order-1
                  lg:order-2
                `}
              >
                <div
                  className={`
                    ${isDesktopOrLaptop ? `max-h-180` : `max-h-151`}
                    inline-flex
                    rounded-full
                    p-3
                    border-6
                    border-solid
                    border-blue-default
                    lg:ml-11.5vw
                  `}
                >
                  <img
                    className={`rounded-full`}
                    src={(browserName === 'safari' && browserVersion < 15) ? Person4Safari14 : Person4}
                    width={isDesktopOrLaptop ? '144' : '115'}
                    height={isDesktopOrLaptop ? '144' : '115'}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 5)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              transform
              opacity-0
              translate-x-1/10

              ${isVisible[5]? (isDesktopOrLaptop ? `animate-opacity-x-inverse` : `animate-opacity`) : ``}

              max-w-890
              mb-37
              lg:mb-36vw
              mx-8
              lg:mx-auto
            `}
          >
            <div className={`flex flex-col lg:flex-row items-center w-full`}>
              <div className={`flex flex-1 justify-end`}>
                <div
                  className={`
                    ${isDesktopOrLaptop ? `max-h-180` : `max-h-151`}
                    inline-flex
                    rounded-full
                    p-3
                    border-6
                    border-solid
                    border-blue-default
                    lg:mr-11
                  `}
                >
                  <img
                    className={`rounded-full`}
                    src={(browserName === 'safari' && browserVersion < 15) ? Person5Safari14 : Person5}
                    width={isDesktopOrLaptop ? '144' : '115'}
                    height={isDesktopOrLaptop ? '144' : '115'}
                    alt=""
                  />
                </div>
              </div>
              <div
                className={`
                  relative
                  flex-1
                  text-sm
                  leading-6
                  text-white
                `}
              >
                <h3
                  className={`
                    uppercase
                    font-semibold
                    text-8.5xl
                    lg:text-10xl
                    lg:ml-11.5
                    -mt-8
                    lg:-mt-0
                    -mb-12
                    lg:-mb-12
                    leading-2
                    text-blue-default
                  `}
                >
                  “
                </h3>
                <span
                  className={`
                    lg:-mr-20
                    block
                    relative
                    text-base
                    lg:text-xl
                    leading-7-important
                    lg:leading-9-important
                    italic font-medium
                    mb-4
                    lg:mb-5vw
                    lg:ml-11
                  `}>
                  Сложилась ситуация, в которой «Северный поток – 2» стал незаменим для такой промышленно развитой страны, как Германия.
                </span>
                <span
                  className={`
                    lg:-mr-15
                    block relative text-right
                    text-xxs
                    lg:text-sm
                    italic
                    lg:ml-11
                  `}>
                  — Председатель партии «Альтернатива для Германии»
                  <br />
                  Йорг Мойтен
                </span>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 6)}
          root={null}
          rootMargin={isDesktopOrLaptop ? `0% 0% 0%` : `0% 0% 0%`}
        >
          <div
            className={`
              ${isVisible[6]? `animate-opacity` : ``}

              transform
              opacity-0
              translate-y-full
              relative
              z-3
            `}
          >
            <AnimatedLinks
              id={`page5-link1`}
              className={`transform transition-transform duration-1000 lg:hover:scale-110`}
              title={`Дорога смычка: как завершение СП-2 скажется на газовых ценах в Европе`}
              body={`И почему они продолжают бить рекорды`}
              link={`https://iz.ru/1219983/irina-kezik/doroga-smychka-kak-zavershenie-sp-2-skazhetsia-na-gazovykh-tcenakh-v-evrope`}
              href={(browserName === 'safari' && browserVersion < 15) ? Image1Safari14 : Image1}
              size={`md`}
              isDesktopOrLaptop={isDesktopOrLaptop}
            />
          </div>
        </Observer>

      </article>
    </Observer>
  );
}